import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import CircularLoading from '../components/CircularLoading';

export default function LandingPage(props) {
  const auth = useSelector(state => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (auth && auth.profile && auth.profile.uid) {
      const role = auth.profile.usertype;
      if (role === 'admin' || role === 'fleetadmin') {
        navigate('/dashboard', { replace: true });
      } else if (role === 'driver' || role === 'customer') {
        navigate('/bookings', { replace: true });
      }
    }
  }, [auth, navigate]);

  if (auth && auth.loading) {
    return <CircularLoading />;
  }

  // If unauthenticated, render the sleek HIILLA Portal Login directly
  return <LoginPage {...props} />;
}

